import { z } from 'zod';
export const phoneSchema = z
    .string()
    .regex(/^\+998\d{9}$/, 'Telefon +998XXXXXXXXX formatida bo\'lishi kerak');
export const plateSchema = z
    .string()
    .regex(/^\d{2}[A-Z]\d{3}[A-Z]{2}$/, 'Davlat raqami noto\'g\'ri formatda (masalan: 01A123BC)');
export const vinSchema = z.string().length(17, 'VIN 17 ta belgidan iborat bo\'lishi kerak');
export const createOrderSchema = z.object({
    carId: z.string().min(1),
    clientId: z.string().min(1),
    problem: z.string().min(3).max(2000),
    mileageAtIntake: z.coerce.number().int().nonnegative().optional(),
    notesInternal: z.string().max(2000).optional(),
});
export const createServiceLogSchema = z.object({
    type: z.enum(['WORK', 'PART', 'NOTE']),
    description: z.string().min(1).max(500),
    qty: z.coerce.number().positive().default(1),
    unitPrice: z.coerce.number().nonnegative().default(0),
    photoUrls: z.array(z.string().url()).default([]),
});
export const createPaymentSchema = z.object({
    method: z.enum(['CASH', 'CARD', 'CLICK', 'PAYME', 'DEBT']),
    amount: z.coerce.number().positive(),
    externalId: z.string().optional(),
});
export const createBookingSchema = z.object({
    workshopId: z.string().min(1),
    serviceId: z.string().min(1),
    carId: z.string().min(1).optional(),
    scheduledAt: z.coerce.date(),
    customerNote: z.string().max(500).optional(),
});
export const createReviewSchema = z.object({
    rating: z.coerce.number().int().min(1).max(5),
    text: z.string().max(2000).optional(),
    photos: z.array(z.string().url()).default([]),
});
export const createClientSchema = z.object({
    name: z.string().min(1).max(100),
    phone: phoneSchema,
    telegramId: z.string().optional(),
});
export const createCarSchema = z.object({
    plate: plateSchema,
    vin: vinSchema.optional().or(z.literal('')),
    brand: z.string().min(1).max(50),
    model: z.string().min(1).max(50),
    year: z.coerce.number().int().min(1900).max(new Date().getFullYear() + 1).optional(),
    color: z.string().max(30).optional(),
    ownerClientId: z.string().min(1),
});
export const createWorkshopSchema = z.object({
    name: z.string().min(2).max(100),
    slug: z
        .string()
        .min(2)
        .max(50)
        .regex(/^[a-z0-9-]+$/, 'faqat kichik harflar, raqamlar va tire'),
    description: z.string().max(1000).optional(),
    address: z.string().max(200).optional(),
    city: z.string().max(50).optional(),
    lat: z.coerce.number().optional(),
    lng: z.coerce.number().optional(),
    phone: phoneSchema.optional().or(z.literal('')),
    workingHours: z.record(z.object({ open: z.string(), close: z.string() }).nullable()).optional(),
});
export const addMemberSchema = z.object({
    telegramId: z.string().min(1),
    roleInWorkshop: z.enum(['OWNER', 'MANAGER', 'MECHANIC', 'VIEWER']).default('MECHANIC'),
    name: z.string().min(1).max(100).optional(),
});
//# sourceMappingURL=index.js.map